import { PaperSize } from "../types/paper";
import HourglassGlobals from "./globals";

export function congPaperSize(paperSizeSetting?: PaperSize): PaperSize {
  return paperSizeSetting ?? HourglassGlobals.cong!.country.paper_size;
}
